import * as React from 'react';
import { Box, Image, Text } from 'wix-style-react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { Theme } from '@src/types';
import { DataHooks } from '@src/constants/data-hooks';
import { AppContext } from '@src/context/store';
import { getTheme } from '@src/context/selectors/app-settings';
import { getLiveSiteUrl } from '@src/context/selectors/ui-settings';

import bannerLight from './images/banner-light.svg';
import bannerDark from './images/banner-dark.svg';
import popupLight from './images/popup-light.svg';
import popupDark from './images/popup-dark.svg';
import * as css from './theme-preview.scss';

export type TThemeSkin = 'banner' | 'popup';
interface Props extends InjectedTranslateProps {
  skin: TThemeSkin;
}

const ThemePreviewComponent = ({ t, skin }: Props) => {
  const store = React.useContext(AppContext);

  const theme = getTheme(store);
  const liveSiteUrl = getLiveSiteUrl(store);

  const renderBannerTheme = () =>
    theme === Theme.light ? (
      <Image dataHook={DataHooks.ThemeBannerPreviewImageLight} className={css.previewImageShadow} src={bannerLight} />
    ) : (
      <Image dataHook={DataHooks.ThemeBannerPreviewImageDark} className={css.previewImageShadow} src={bannerDark} />
    );

  const renderPopupTheme = () =>
    theme === Theme.light ? (
      <Image dataHook={DataHooks.ThemePopupPreviewImageLight} className={css.previewImageShadow} src={popupLight} />
    ) : (
      <Image dataHook={DataHooks.ThemePopupPreviewImageDark} className={css.previewImageShadow} src={popupDark} />
    );
  return (
    <Box dataHook={DataHooks.ThemePreviewContainer} align="right">
      <Box className={css.previewContainer} padding={'30px'} width={372} height={384} direction="vertical">
        <Box>{skin === 'banner' ? renderBannerTheme() : renderPopupTheme()}</Box>
        <Box marginTop={'24px'} textAlign="center">
          <Text size="small">
            {t('text-and-display.preview-theme.info-part1')}
            <a href={liveSiteUrl} target="_blank">
              {t('text-and-display.preview-theme.info-link')}
            </a>
            {t('text-and-display.preview-theme.info-part2')}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export const ThemePreview = translate()(ThemePreviewComponent);
